module.exports = __webpack_public_path__ + "img/icon-failed.81119fa6.png";